import * as React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Fade from '@mui/material/Fade'
import { useNavigate } from 'react-router-dom'
import { PATH_DASHBOARD } from 'routes/paths'
import { useState, useContext } from 'react'
import { GlobalInfoContext, initialState } from 'contexts/GlobalStateContext'
import { INFO, SECONDARY } from 'theme/palette'
import { Icon } from '@iconify/react'

export default function CreatePaperGuarantee() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()

  const { setReqInfo } = useContext(GlobalInfoContext)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)

  const handleClose = () => setAnchorEl(null)
  const handlePaperNavigate = (type: string) => {
    handleClose()
    setReqInfo({ ...initialState, purpose: null, initiatedBy: type, guaranteeType: 'paper' })
    const createAs = type === 'applicant' ? 'createPaperGxAppl' : 'createPaperGxBene'
    navigate(PATH_DASHBOARD.general.guaranteeCreate[createAs])
  }

  return (
    <>
      <Button
        id="fade-button"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="contained"
        sx={{
          borderRadius: '4px',
          width: '260px',
          margin: '30px 0 0 20px',
          padding: '11px 22px',
          boxShadow: 0,
          backgroundColor: SECONDARY.light,
          border: 0,
          color: '#000000',
          ':hover': {
            bgcolor: INFO.dark,
            boxShadow: 0,
            border: 0
          }
        }}
      >
        Register Paper Guarantee&nbsp;
        <Icon icon="ph:caret-down-bold" />
      </Button>
      <Menu
        id="fade-menu-paper"
        MenuListProps={{
          'aria-labelledby': 'fade-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiMenuItem-root': {
            '&:hover': {
              backgroundColor: '#FF5500',
              border: 0
            }
          }
        }}
        PaperProps={{
          style: {
            width: '260px',
            borderRadius: 0
          }
        }}
        TransitionComponent={Fade}
      >
        <MenuItem sx={{ fontSize: '14px' }} onClick={() => handlePaperNavigate('applicant')}>
          Create as Paper Applicant
        </MenuItem>
        <MenuItem sx={{ fontSize: '14px' }} onClick={() => handlePaperNavigate('beneficiary')}>
          Create as Paper Beneficiary
        </MenuItem>
      </Menu>
    </>
  )
}
